import { render, staticRenderFns } from "./ShoppingLive.vue?vue&type=template&id=7af48120&"
import script from "./ShoppingLive.vue?vue&type=script&lang=js&"
export * from "./ShoppingLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports